










































import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { LoginView } from '@vsoft/web-ui-system';
import { ValidationObserver } from 'vee-validate';
import VsSelectWithButton from './components/vs-SelectWithButton.vue';

import VsLoaging from '@/components/vs-Loading.vue';
import VsIcon from '@/components/vs-Icon.vue';

require('@/assets/css/buttons.css');
require('@/assets/css/margins.css');
require('@/assets/css/texts.css');
require('@/assets/css/transitions.css');

@Component({ components: { LoginView, ValidationObserver, VsSelectWithButton, VsLoaging, VsIcon } })
class App extends Vue {
    private get googleKey() {
        return process.env.VUE_APP_GOOGLE_API_KEY;
    } 
    private loading: boolean = false;
    private error: string = '';
    private state: string = '';
    private states: {name: string; value: string}[] = [
        // { value: "AC", name: 'Acre' },
        { value: "AL", name: 'Alagoas' },
        // { value: "AM", name: 'Amazonas' },
        // { value: "AP", name: 'Amapá' },
        { value: "BA", name: 'Bahia' },
        { value: "CE", name: 'Ceará' },
        // { value: "DF", name: 'Distrito Federal' },
        { value: "ES", name: 'Espirito Santo' },
        { value: "GO", name: 'Goiás' },
        { value: "MA", name: 'Maranhão' },
        { value: "MG", name: 'Minas Gerais' },
        { value: "MS", name: 'Mato Grosso do Sul' },
        // { value: "MT", name: 'Mato Grosso' },
        // { value: "PA", name: 'Pará' },
        { value: "PB", name: 'Paraíba' },
        { value: "PE", name: 'Pernambuco' },
        // { value: "PI", name: 'Piauí' },
        { value: "PR", name: 'Paraná' },
        // { value: "RJ", name: 'Rio de Janeiro' },
        { value: "RN", name: 'Rio Grande do Norte' },
        // { value: "RO", name: 'Rondônia' },
        // { value: "RR", name: 'Roraima' },
        // { value: "RS", name: 'Rio Grande do Sul' },
        { value: "SC", name: 'Santa Catarina' },
        { value: "SE", name: 'Sergipe' },
        { value: "SP", name: 'São Paulo' },
        // { value: "TO", name: 'Tocantins' }
    ];

    private submit(): void {
        if(this.loading) {
            return;
        }
        this.error = '';
        this.loading = true;
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                await this.getEstado(position);
                this.loading = false;
                this.redirectSuperaula();
            },
            (positionError) => {
                this.showError(positionError);
                this.loading = false;
            }
        );
    }

    private async getEstado(position: any) {
        let url = 'https://maps.googleapis.com/maps/api/geocode/json?';
        url +=`latlng=${position.coords.latitude},${position.coords.longitude}`;
        url +=`&key=${this.googleKey}`;
        try {
            const resp = await axios.get(url);
            if(resp.data && resp.data.results && resp.data.results.length > 0){
                const objEndereco = resp.data.results[0].address_components;
                
                if(!objEndereco) {
                    this.error = 'Nenhum estado foi encontrado com a localização capturada. Por favor, selecione o estado.';
                    return;
                }

                const estado = objEndereco.find((x: any) => {
                    if(x.types.includes('administrative_area_level_1'))
                        return true;
                });
                if(!estado) {
                    this.error = 'Nenhum estado foi encontrado com a localização capturada. Por favor, selecione o estado.';
                    return;
                }

                this.state = estado.short_name;
            } else {
                console.log(resp.data);
                this.error = 'Não foi possível realizar consulta da sua localização no Google Maps. Por favor, selecione o estado.';      
            }
        } catch (error) {
            console.log(error);
            this.error = 'Não foi possível realizar consulta da sua localização no Google Maps. Por favor, selecione o estado.';            
        }
        
    }

    private showError(error: any) {
        switch(error.code) {
            case error.PERMISSION_DENIED:
                this.error = "Você não autorizou o compartilhamento da sua localização. Por favor, selecione o estado.";
                break;
            case error.POSITION_UNAVAILABLE:
                this.error = "Localização indisponível. Por favor, selecione o estado.";
                break;
            case error.TIMEOUT:
                this.error = "A requisição expirou. Tente novamente.";
                break;
            default:
                this.error = "Algum erro desconhecido aconteceu. Por favor, selecione o estado.";
                break;
        }
    }
    private redirectSuperaula() {
        window.location.href = `https://${this.state}.superau.la`;
    }

    private beforeCreate(): void {
        localStorage.clear();
    }
}

export default App;
